const SEO = [
	{
		page: "home",
		description:
			"Vishal Naikawadi is a Tech Lead and React Native mobile engineer with 8 years of experience across architecture, AI product features, automation, Expo/EAS builds, and app releases.",
		keywords: ["Vishal Naikawadi", "React Native", "Tech Lead", "Mobile Engineer", "AI"],
	},

	{
		page: "about",
		description:
			"About Vishal Naikawadi, a Mumbai based Tech Lead focused on React Native, React, AI-enabled mobile products, Solo Saga, Claripath, release ownership, and product thinking.",
		keywords: ["Vishal Naikawadi", "React Native", "React", "Solo Saga", "Claripath", "Mobile Architecture"],
	},

	{
		page: "articles",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
		keywords: ["Vishal", "Vishal N", "Vishal Naikawadi"],
	},

	{
		page: "projects",
		description:
			"Selected mobile projects by Vishal Naikawadi, including Quicktakes.ai, LEAD Student App, mAudit, Solo Saga, and Claripath.",
		keywords: ["Vishal Naikawadi", "Quicktakes.ai", "LEAD Student App", "React Native projects"],
	},

	{
		page: "contact",
		description:
			"Contact Vishal Naikawadi for React Native, mobile architecture, AI-enabled product features, automation, and app release work.",
		keywords: ["Vishal Naikawadi", "Contact", "React Native", "Mobile Engineer"],
	},
];

export default SEO;
